import React, { useEffect } from 'react';
import { ProjectActions } from 'app/stores/project/actions';
import { getSelectedMarkers } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { EditBoundsPoints } from 'app/views/components/editor/tools/edit/EditBoundsPoints';
import { EditImage } from 'app/views/components/editor/tools/edit/EditImage';
import { EditPolyline } from 'app/views/components/editor/tools/edit/EditPolyline';
import { EditText } from 'app/views/components/editor/tools/edit/EditText';
import { EditTwoPoints } from 'app/views/components/editor/tools/edit/EditTwoPoints';
import { EditZoom } from 'app/views/components/editor/tools/edit/EditZoom';
import { useConnect } from 'app/views/hooks/useConnect';
import { stopPropagation } from 'app/utils/events';
const ToolEditComponent = {
    Arrow: EditTwoPoints,
    Line: EditTwoPoints,
    Ellipse: EditBoundsPoints,
    Rect: EditBoundsPoints,
    Blur: EditBoundsPoints,
    Spot: EditBoundsPoints,
    Zoom: EditZoom,
    Text: EditText,
    Polyline: EditPolyline,
    Image: EditImage,
};
export const MarkerEdit = () => {
    const dispatch = useAppDispatch();
    const stateProps = useConnect(state => {
        const { activeTool } = state.editor;
        const markers = getSelectedMarkers(state);
        if (markers.length !== 1) {
            return { activeTool };
        }
        const marker = markers[0];
        return {
            selectedItemId: marker.id,
            selectedItemAlias: marker.alias,
            selectedItemIsLocked: marker.locked === true,
        };
    });
    const { selectedItemId, selectedItemAlias, selectedItemIsLocked } = stateProps;
    useEffect(() => {
        const onKeyDown = (evt) => {
            switch (evt.key) {
                case 'Escape':
                    if (selectedItemAlias) {
                        dispatch(ProjectActions.clearSelection());
                    }
                    stopPropagation(evt);
                    break;
                case 'Backspace':
                case 'Delete':
                    if (selectedItemId) {
                        dispatch(ProjectActions.deleteItems({
                            ids: [selectedItemId],
                        }));
                        stopPropagation(evt);
                    }
                    break;
                default:
                    break;
            }
        };
        document.addEventListener('keydown', onKeyDown, true);
        return () => document.removeEventListener('keydown', onKeyDown, true);
    }, [selectedItemId, selectedItemAlias, dispatch]);
    const EditComponent = selectedItemAlias
        ? ToolEditComponent[selectedItemAlias]
        : undefined;
    if (!selectedItemIsLocked && EditComponent) {
        return (
        // <div className="interaction">
        React.createElement(EditComponent, null)
        // </div>
        );
    }
    return null;
};
